import { Button } from '@material-ui/core';
import LaunchIcon from '@material-ui/icons/Launch';
import { Trans } from '@lingui/macro';
import { usePlmPath } from '../../utilities/PgmUtilities';

export default function LinkButton({ url, newTab = false, label, tooltip }) {
    const linkLocation = usePlmPath(url);
    const buttonProps = newTab
        ? {
              target: '_blank',
              endIcon: <LaunchIcon />,
          }
        : {};

    if (tooltip) {
        buttonProps.title = tooltip;
    }

    return (
        <Button {...buttonProps} href={linkLocation}>
            <Trans>{label}</Trans>
        </Button>
    );
}
